/*--公共接口---*/
// 上传文件、图片接口
import * as http from './http';

// export const reqFileUpload = (params) => http.post('/file/upload', params)
export const reqFileUpload = (params) => http.post('/file/upload', params, {
	'Content-Type': 'multipart/form-data'
})

// 用户协议
export const reqContract = (params) => http.post('/ruleDesc/ruleDescDetail', params)

// 获取appid
export const reqGetAppid = () => http.post('/wechat/pa/getAppId', null, { loading: false, interceptRes: true })

// 获取支付方式
export const reqPayTypeList = (params) => http.post('/payTypeChannel/list', params, { loading: false, interceptRes: true })

